"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseShareAppActionYamlConfig = void 0;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const pathUtils_1 = require("../../utils/pathUtils");
const metadataUtil_1 = require("../../utils/metadataUtil");
const localizeUtils_1 = require("../../../common/localizeUtils");
const envUtil_1 = require("../../utils/envUtil");
const lifecycle_1 = require("../../configManager/lifecycle");
const path_1 = tslib_1.__importDefault(require("path"));
const adm_zip_1 = tslib_1.__importDefault(require("adm-zip"));
const constants_1 = require("../teamsApp/constants");
const shareToOthers = tslib_1.__importStar(require("./shareToOthers"));
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
// Read teamsapp.yaml and get the value of teamsapp id, shared title id, and shared app id
// Output [teamsapp id, shared title id, shared app id]
async function parseShareAppActionYamlConfig(projectPath) {
    var _a, _b, _c;
    const templatePath = pathUtils_1.pathUtils.getYmlFilePath(projectPath, "dev");
    const maybeProjectModel = await metadataUtil_1.metadataUtil.parse(templatePath);
    if (maybeProjectModel.isErr()) {
        return (0, teamsfx_api_1.err)(maybeProjectModel.error);
    }
    const projectModel = maybeProjectModel.value;
    if (!projectModel.share || !projectModel.share.driverDefs) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share to Users", (0, localizeUtils_1.getLocalizedString)("error.share.yamlConfigNotFound")));
    }
    const shareToOthersAction = projectModel.share.driverDefs.find((d) => d.uses === shareToOthers.actionName);
    if (!shareToOthersAction) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share to Users", (0, localizeUtils_1.getLocalizedString)("error.share.shareActionConfigNotFound", shareToOthers.actionName)));
    }
    // 1. get manifest id
    const appPackagePath = (_a = shareToOthersAction.with) === null || _a === void 0 ? void 0 : _a.appPackagePath;
    if (!appPackagePath) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share to Users", (0, localizeUtils_1.getLocalizedString)("error.share.appPackageConfigNotFound")));
    }
    const readEnvRes = await envUtil_1.envUtil.readEnv(projectPath, "dev");
    if (readEnvRes.isErr()) {
        return (0, teamsfx_api_1.err)(readEnvRes.error);
    }
    const resolvedDriver = (0, lifecycle_1.resolve)(shareToOthersAction, [], []);
    const resolvedAppPackagePath = path_1.default.resolve(projectPath, resolvedDriver.with.appPackagePath);
    if (!fs_extra_1.default.existsSync(resolvedAppPackagePath)) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share", (0, localizeUtils_1.getLocalizedString)("error.share.appPackageNotFound", resolvedAppPackagePath)));
    }
    const zipEntries = new adm_zip_1.default(resolvedAppPackagePath).getEntries();
    const manifestFile = zipEntries.find((x) => x.entryName === constants_1.Constants.MANIFEST_FILE);
    if (!manifestFile) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share to Users", (0, localizeUtils_1.getLocalizedString)("error.share.manifestFileNotFound")));
    }
    const manifest = JSON.parse(manifestFile.getData().toString());
    const manifestId = manifest.id;
    if (!manifestId) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share to Users", (0, localizeUtils_1.getLocalizedString)("error.share.manifestIdNotFound")));
    }
    // 2. get shared title id and shared app id
    const sharedTitleIdEnvName = (_b = shareToOthersAction.writeToEnvironmentFile) === null || _b === void 0 ? void 0 : _b.titleId;
    const sharedAppIdEnvName = (_c = shareToOthersAction.writeToEnvironmentFile) === null || _c === void 0 ? void 0 : _c.appId;
    if (!sharedTitleIdEnvName || !sharedAppIdEnvName) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share to Users", (0, localizeUtils_1.getLocalizedString)("error.share.sharedConfigNotFound")));
    }
    // env file has already been loaded before calling this function.
    const sharedTitleId = process.env[sharedTitleIdEnvName];
    const sharedAppId = process.env[sharedAppIdEnvName];
    if (!sharedTitleId || !sharedAppId) {
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError("FxCore", "Share to Users", (0, localizeUtils_1.getLocalizedString)("error.share.sharedIdNotFound", sharedTitleId, sharedAppId)));
    }
    return (0, teamsfx_api_1.ok)([manifestId, sharedTitleId, sharedAppId]);
}
exports.parseShareAppActionYamlConfig = parseShareAppActionYamlConfig;
//# sourceMappingURL=utils.js.map